import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const BrandList = lazy(() => import('./index'));
const BrandDetail = lazy(() => import('./brand-detail/index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/brand-list',
    element: <BrandList />,
  },
  {
    path: '/brand-detail',
    element: <BrandDetail />,
  },
];
